<mat-card [class.mat-elevation-z3]="cardIsPopover()">
  <mat-card-header>
    <!--  -->

    <glxy-avatar
      mat-card-avatar
      [width]="36"
      class="user-avatar"
      [src]="cardData().avatar || ''"
      [icon]="cardData().type === 'user' ? 'person' : 'business'"
    />

    <!-- User -->
    @if (cardData().type === 'user' && cardData().userName) {
      <mat-card-title class="name">
        {{ cardData().userName }}
      </mat-card-title>
    }
    @if (cardData().type === 'user' && cardData().email) {
      <mat-card-subtitle class="email">
        {{ cardData().email }}
      </mat-card-subtitle>
    }

    <!-- Business -->
    @if (cardData().type === 'business' && cardData().businessName) {
      <mat-card-title class="name">
        {{ cardData().businessName }}
      </mat-card-title>
    }
    @if (cardData().type === 'business' && cardData().businessWebsite) {
      <mat-card-subtitle class="website">
        <a [href]="cardData().businessWebsite" target="_blank" rel="noopener">{{ cardData().businessWebsite }}</a>
      </mat-card-subtitle>
    }

    <!--  -->
  </mat-card-header>
  <mat-card-content>
    <!--  -->

    @if (cardData().type === 'user' && cardData().businessName) {
      <div class="business-info">
        <mat-icon inline class="card-icon">business</mat-icon>
        {{ cardData().businessName }}
      </div>
    }

    @if (cardData().id) {
      <div class="business-info" [cdkCopyToClipboard]="cardData().id!">
        <mat-icon inline class="card-icon">badge</mat-icon>
        <span class="business-id">
          {{ cardData().id }}
        </span>
        <button
          mat-icon-button
          class="card-icon copy-card-icon"
          [class.clicked-icon]="isCopied()"
          (click)="copyClicked()"
          [glxyTooltip]="isCopied() ? 'Copied' : 'Click to copy'"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    }

    @if (cardData()?.type === 'business' && fullBusinessAddress()) {
      <div class="business-info">
        <mat-icon inline class="card-icon">location_on</mat-icon>
        <div class="full-business-address">{{ fullBusinessAddress() }}</div>
      </div>
    }
  </mat-card-content>
  <mat-card-actions [class.user-supplied-template]="actionsRef() || !showDefaultActions()">
    <!--  -->

    @if (actionsRef()) {
      <ng-container *ngTemplateOutlet="actionsRef()" />
    } @else {
      @if (showDefaultActions()) {
        @if (cardData().profileButtonUrl || cardData().profileButtonAction) {
          <a
            mat-button
            color="primary"
            style="margin-right: auto"
            [attr.href]="
              !cardData().profileButtonUrlUseRouterLink && cardData().profileButtonUrl
                ? cardData().profileButtonUrl
                : null
            "
            (click)="handleProfileButtonClick()"
          >
            {{ cardData().profileButtonLabel ?? 'View details' }}
          </a>
        }
        @if (cardData().phone) {
          <button mat-icon-button color="primary" [matMenuTriggerFor]="phoneMenu">
            <mat-icon>call</mat-icon>
          </button>
          <mat-menu #phoneMenu="matMenu">
            <button mat-menu-item [cdkCopyToClipboard]="cardData().phone!">
              <mat-icon>content_copy</mat-icon>
              Copy phone number
            </button>
            <a mat-menu-item href="tel:{{ cardData().phone }}">
              <mat-icon>phone_forwarded</mat-icon>
              Call {{ cardData().userName ?? cardData().businessName ?? cardData().phone }}
            </a>
            <div class="action-menu-data" mat-menu-item disabled>
              <span class="data">{{ cardData().phone }}</span>
            </div>
          </mat-menu>
        }
        @if (cardData().email) {
          <button mat-icon-button color="primary" [matMenuTriggerFor]="emailMenu">
            <mat-icon>mail</mat-icon>
          </button>
          <mat-menu #emailMenu="matMenu">
            <button mat-menu-item [cdkCopyToClipboard]="cardData().email!">
              <mat-icon>content_copy</mat-icon>
              Copy email address
            </button>
            <a mat-menu-item href="mailto:{{ cardData().email }}" target="_blank" rel="noopener">
              <mat-icon>email</mat-icon>
              Send email
              {{
                cardData().userName || cardData().businessName
                  ? 'to ' + (cardData().userName ?? cardData().businessName)
                  : ''
              }}
            </a>
            <div class="action-menu-data" mat-menu-item disabled>
              <span class="data">{{ cardData().email }}</span>
            </div>
          </mat-menu>
        }
        <!--  -->
      }
      <!-- Inject any extra content after the default actions -->
      <ng-content />
    }
  </mat-card-actions>
</mat-card>
